module.exports = __webpack_public_path__ + "static/media/ic_location_on_selected_36px.ed1fc8b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_location_on_selected_36px.svg
// module id = 798
// module chunks = 0